import { USE_REACT_ROUTER } from '../../define/global';
import { getCurrentFormatByPath, getCurrentFormatByQuery, getCurrentFormatByURL } from './policys';

export const selectCurrentFormat = (location) => {
  //const [policy, ...arg] = process.env.REACT_APP_FORMAT_SELECTION_POLICY.split('/');
  //getCurrentFormatByQuery("format");

  return USE_REACT_ROUTER ?
   getCurrentFormatByPath(location,2)
    : getCurrentFormatByURL(); //getCurrentFormatByQuery("format"); 
};
